import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogData } from './confirmation-dialog-data.interface';

@Component({
    templateUrl: './confirmation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ConfirmationDialogComponent {
    constructor(
        private readonly matDialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) readonly data: ConfirmationDialogData,
    ) {}

    onConfirmation(isConfirm: boolean): void {
        this.matDialogRef.close(isConfirm);
    }
}
